define('core/oidc-configuration',[
    'core/can',
    'oidc-client'
], function (can, Oidc) {
    return can.Construct.extend({
        userManager: {}

    }, {
            init: function () {
                var settings = new Oidc.OidcClientSettings({
                    authority: 'https://identity.axxessweb.com/',
                    client_id: 'Axxess-Dde-Frontend',
                    redirect_uri: this.getUrlFromLocation('/#!&page=signinoidc&'),
                    post_logout_redirect_uri: this.getUrlFromLocation('/#!&page=signoutoidc&'),
                    response_type: 'id_token token',
                    scope: 'openid email profile',

                    filterProtocolClaims: true,
                    loadUserInfo: false,

                    stateStore: new Oidc.WebStorageStateStore({
                        prefix: 'dde-oidc.',
                        store: window.localStorage
                    }),
                });
                this.userManager = new Oidc.UserManager(settings);
            },
            signIn: function () {
                this.userManager.signinRedirect();
            },

            getUrlFromLocation: function (subPath) {
                return window.location.protocol + '//' + window.location.host + subPath
            },

            userSignedOut: function () {
                this.userManager.removeUser().then(function () {
                    window.location.reload();
                });
            },

            oidcSignOut: function () {
                this.userManager.signoutRedirect();
            }
        })
});


